(function(){
  const MONEY_FMT = (v) => (v/100).toLocaleString('fr-FR', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' Dhs';
  const FREE_SHIP = 50000;

  const $ = (sel, root) => (root||document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root||document).querySelectorAll(sel));

  let cartState = null;

  function open(){
    document.body.classList.add('nwidea-cart-open');
    $('.nwidea-cart-drawer').classList.add('open');
    $('.nwidea-cart-overlay').classList.add('open');
    fetchCart();
  }
  function close(){
    document.body.classList.remove('nwidea-cart-open');
    $('.nwidea-cart-drawer').classList.remove('open');
    $('.nwidea-cart-overlay').classList.remove('open');
  }
  function showLoading(s){ const l=$('.nwidea-cart-loading'); if(l) l.classList.toggle('show', !!s); }

  async function fetchCart(){
    showLoading(true);
    try{
      const r = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
      const cart = await r.json();
      cartState = cart;
      render(cart);
      updateCount(cart.item_count);
    } catch(e){ console.error(e); }
    showLoading(false);
  }

  async function updateLine(key, qty){
    showLoading(true);
    try{
      const r = await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id:key, quantity:qty})
      });
      const cart = await r.json();
      cartState = cart;
      render(cart);
      updateCount(cart.item_count);
    } catch(e){ console.error(e); }
    showLoading(false);
  }

  function updateCount(n){
    $$('.nwidea-header__dot, .nwidea-drawer__foot a[href*=cart]').forEach(el => {
      if (el.classList.contains('nwidea-header__dot')) el.textContent = n;
      else if (el.textContent.includes('Panier')) el.innerHTML = el.innerHTML.replace(/\(\d+\)/, '('+n+')');
    });
  }

  function renderProps(props){
    if (!props) return '';
    let html = '';
    Object.entries(props).forEach(([k, v]) => {
      if (!k || k.startsWith('_') || !v) return;
      const isFile = typeof v === 'string' && (v.startsWith('/uploads/') || v.startsWith('https://cdn.shopify.com/'));
      const val = isFile ? `<a href="${v}" target="_blank" rel="noopener">Voir le fichier</a>` : v;
      html += `<div class="nwidea-prop"><b>${k}&thinsp;:</b> ${val}</div>`;
    });
    return html;
  }

  function render(cart){
    const wrap = $('.nwidea-cart-body');
    const foot = $('.nwidea-cart-foot');
    const head = $('.nwidea-cart-head h2 .ct');
    if (head) head.textContent = '(' + cart.item_count + ')';

    if (!cart.items || cart.items.length === 0){
      wrap.innerHTML = `
        <div class="nwidea-cart-progress">Votre panier est vide</div>
        <div class="nwidea-cart-empty">
          <svg viewBox="0 0 24 24"><path d="M6 7h12l-1.5 12.5a1 1 0 0 1-1 .9H8.5a1 1 0 0 1-1-.9L6 7Z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>
          <h3>Votre panier est vide</h3>
          <p>Parcourez nos collections pour trouver vos pi&egrave;ces favorites.</p>
          <a href="/collections/all" class="nwidea-btn solid" onclick="NwideaCart.close()">Voir la boutique</a>
        </div>`;
      foot.style.display = 'none';
      return;
    }
    foot.style.display = 'block';

    const remaining = Math.max(0, FREE_SHIP - cart.total_price);
    const pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
    let progressHtml;
    if (remaining > 0) {
      progressHtml = `<div class="nwidea-cart-progress">Plus que <b>${MONEY_FMT(remaining)}</b> pour la livraison offerte<div class="bar"><span style="width:${pct}%"></span></div></div>`;
    } else {
      progressHtml = `<div class="nwidea-cart-progress ok">&#10003; Livraison offerte<div class="bar"><span style="width:100%"></span></div></div>`;
    }

    let itemsHtml = '<div class="nwidea-cart-items">';
    cart.items.forEach(item => {
      const variant = item.variant_options && item.variant_options.length && item.variant_options[0] !== 'Default Title' ? `<div class="nwidea-cart-item__variant">${item.variant_options.join(' / ')}</div>` : '';
      const propsHtml = renderProps(item.properties);
      itemsHtml += `
        <div class="nwidea-cart-item" data-key="${item.key}">
          <div class="nwidea-cart-item__img"><img src="${item.image || ''}" alt="${item.product_title}" loading="lazy"></div>
          <div class="nwidea-cart-item__info">
            <div>
              <a href="${item.url}" class="nwidea-cart-item__title">${item.product_title}</a>
              ${variant}
              ${propsHtml}
            </div>
            <div class="nwidea-cart-item__qty">
              <button type="button" data-act="dec">−</button>
              <input type="number" value="${item.quantity}" min="0" readonly>
              <button type="button" data-act="inc">+</button>
            </div>
          </div>
          <div class="nwidea-cart-item__right">
            <div class="nwidea-cart-item__price">${MONEY_FMT(item.final_line_price)}</div>
            <button type="button" class="nwidea-cart-item__remove" data-act="rem">Retirer</button>
          </div>
        </div>`;
    });
    itemsHtml += '</div>';

    wrap.innerHTML = progressHtml + itemsHtml;

    $('.nwidea-cart-foot__sub span').textContent = MONEY_FMT(cart.total_price);

    $$('.nwidea-cart-item', wrap).forEach(row => {
      const key = row.dataset.key;
      const qty = parseInt(row.querySelector('input').value);
      row.querySelector('[data-act=dec]').onclick = () => updateLine(key, Math.max(0, qty-1));
      row.querySelector('[data-act=inc]').onclick = () => updateLine(key, qty+1);
      row.querySelector('[data-act=rem]').onclick = () => updateLine(key, 0);
    });
  }

  async function addToCart(formEl){
    showLoading(true);
    try{
      const fd = new FormData(formEl);
      const r = await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Accept':'application/json'},
        body: fd
      });
      if (!r.ok) {
        let msg = 'Erreur lors de l\'ajout au panier';
        try { const err = await r.json(); msg = err.description || err.message || msg; } catch(e){}
        alert(msg);
        showLoading(false);
        return;
      }
      await fetchCart();
      open();
    } catch(e){ console.error(e); showLoading(false); }
  }

  function bindATC(){
    document.addEventListener('submit', function(e){
      const f = e.target;
      if (f.matches && (f.matches('form[action*="/cart/add"]') || f.id && f.id.startsWith('nwidea-pform'))){
        e.preventDefault();
        addToCart(f);
      }
    });
  }

  function init(){
    if (!$('.nwidea-cart-drawer')) return;
    $('.nwidea-cart-overlay').addEventListener('click', close);
    $('.nwidea-cart-close').addEventListener('click', close);

    document.addEventListener('click', function(e){
      const target = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
      if (target && !e.metaKey && !e.ctrlKey && !e.shiftKey){
        e.preventDefault();
        open();
      }
    });

    bindATC();
    fetchCart();
  }

  window.NwideaCart = { open, close, fetchCart };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
